import { TableCellProps } from 'shared/mui/Table';

import { StyledTableCellHeader } from './TableCellHeader.styled';

export type TableCellHeaderProps = { label: React.ReactNode } & TableCellProps;

export const TableCellHeader = ({ label, ...props }: TableCellHeaderProps) => (
  <StyledTableCellHeader {...props} variant="head">
    {label}
  </StyledTableCellHeader>
);
